<template lang="pug">
  .by-package-type
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Id
        th Name
        th Package
        th Count
      tr.clickable(v-for="p in products" @click="$refs.productDetailsModal.open(p.packages)")
        td {{p.productId}}
        td {{p.name}}
        td {{p.packages.package[0].name}}
        td {{p.count}}

    ProductDetailsModal(ref="productDetailsModal")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import TrackNTrace from '@/service/apis/TrackNTrace'
import ProductDetailsModal from './ProductDetailsModal'

export default {
  data() {
    return {
      loading: false,
      locationId: this.$route.params.id,
      products: null
    }
  },
  created() {
    this.loading = true
    TrackNTrace.getLocationProducts(this.locationId)
      .then((resp) => {
        this.products = resp.data.productCounts.productCount
        this.loading = false
      })
      .catch((e) => { this.$emit('error', e) })
  },
  components: {
    GenericTable,
    ProductDetailsModal
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/ByProduct.vue